import axios from 'axios';
import API from '../config/api';
import { resHandle } from '../helper';


export const generateWeeklyReport = params => axios.get(API.ADMIN_GENERATE_REPORT + params).then(res => {
    let { status, data } = resHandle(res);
    return {status, data};
});


